export default __webpack_public_path__ + "static/chi-9a59723db0a9c875ef5e5089bbeabc01.jpeg";